import axios from 'axios';
import AccountType from '@/models/AccountType.js';

export default {
  name: 'Notifications',
  data () {
    return {
      currentAccount: {},
      permissionGroupList: [],
      Checked: [],
      permissionTypes: ['display', 'add', 'edit', 'delete', 'export'],
      title: '',
      displayUserTable: false,
    };
  },
  methods: {
    getAllPermissions () {
      var accountID = this.$route.params.id;
      if (accountID) { this.getAccountPermissions(accountID); } else {
        this.title = 'Create new Account Type';
        this.currentAccount = new AccountType({
          ID: null,
          Users: [],
        });
      }
      axios.get(this.$store.getters.rootAPI + '/permissions/get').then((response) => {
        response.status == 200 ? this.permissionGroupList = response.data : this.permissionGroupList = null;
      });
    },
    getAccountPermissions (id) {
      axios.get(this.$store.getters.rootAPI + '/permissions/getAccountPermissions/' + id).then((response) => {
        this.currentAccount = new AccountType(response.data);
        if (this.currentAccount.Users.length > 0) {
          this.displayUserTable = true;
        }
        this.currentAccount.Permissions.forEach((value) => {
          this.Checked.push(value.ID);
        });
        this.title = 'Edit user rights for ' + this.currentAccount.AccountTypeName;
      });
    },
    submit () {
      if (this.currentAccount.ID !== null) {
        this.currentAccount.Permissions.length = 0;
        this.permissionGroupList.forEach((element) => {
          var SelectedPermissions = element.Permission.filter((x) => this.Checked.indexOf(x.ID) > -1);
          if (SelectedPermissions == 0) {
            return;
          }
          SelectedPermissions.forEach((spElement) => {
            this.currentAccount.Permissions.push(spElement);
          });
        });
        axios.post(this.$store.getters.rootAPI + '/permissions/updateAccountType', this.currentAccount).then((response) => {
          if (response.status == 204) {
            this.$router.push('/settings/accountTypes/');
          }
        });
      } else {
        this.currentAccount.Permissions = this.Checked;
        axios.post(this.$store.getters.rootAPI + '/permissions/createAccountType', this.currentAccount)
          .then((response) => {
            if (response.data.Status) {
              this.$router.push('/settings/accountTypes/');
            } else {
              this.$root.$emit('notification', {
                message: response.data.Message,
                type: 'error',
                show: true,
                listError: response.data.ErrorValues,
              });
            }
          });
      }
    },
    logType (AccountTypeID) {
      // console.log(AccountTypeID);
    },
  },
  mounted () {
    this.getAllPermissions();
  },
};
